import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LoginService } from '../../services/login.service';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-redefinicao-senha-dialog',
  templateUrl: './redefinicao-senha-dialog.component.html',
  styleUrl: './redefinicao-senha-dialog.component.css'
})
export class RedefinicaoSenhaDialogComponent {
  @Input() visivel: boolean = false;
  @Output() public fechar = new EventEmitter();

  email!: string
  emailEnviado: boolean = false
  loading: boolean = false

  constructor(private toastService: ToastService, private loginService: LoginService){}

  escondeDialog() {
    this.visivel = false;

    this.fechar.emit();
  }

  submit(){
    this.loading = true
    this.loginService.solicitacaoRedefinicao(this.email).subscribe({
      next: () => {
        this.toastService.sucesso("Sucesso", "A redefinição foi solicitada, consulte sua caixa de entrada");
        this.escondeDialog();
      },
      error: (erro) => {
        this.toastService.erro("Erro", "Erro na solicitação: " + erro.error)
      },
      complete: () => {
        this.loading = false;
      }
    })
  }
}
